import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getTermsConditionsFailed,
  getTermsConditionsSuccess,
} from '../../store/package/actions';
import { GET_TERMS_CONDITIONS } from '../../store/package/types';
import { getTermsConditions } from '../../api/package';

export const performGetTermsConditions = function*({ payload }) {
  try {
    const { bookingRef } = payload;
    const termsConditions = yield call(getTermsConditions, bookingRef);
    yield put(getTermsConditionsSuccess(bookingRef, termsConditions));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      yield put(getTermsConditionsFailed(payload.bookingRef, true));
    } else {
      yield put(getTermsConditionsFailed(payload.bookingRef));
    }
  }
};

export default takeLatest(GET_TERMS_CONDITIONS, performGetTermsConditions);
